export default "__VITE_ASSET__BpXydfhN__"